// Channels client — list / add / delete per strategy.

import { fetchJson, URLS } from "./client";
import type { AlertChannelConfigDto, AlertChannelDto } from "./types";

export interface AlertChannelCreatedDto {
  channel: AlertChannelDto;
  secret: string;
}

export function listChannels(strategyId: string): Promise<AlertChannelDto[]> {
  return fetchJson<AlertChannelDto[]>(`${URLS.orchestrator}/Strategies/${strategyId}/Channels`);
}

export function addChannel(strategyId: string, config: AlertChannelConfigDto): Promise<AlertChannelCreatedDto> {
  return fetchJson<AlertChannelCreatedDto>(`${URLS.orchestrator}/Strategies/${strategyId}/Channels`, {
    method: "POST",
    body: config,
  });
}

export function deleteChannel(channelId: string): Promise<void> {
  return fetchJson<void>(`${URLS.orchestrator}/Channels/${channelId}`, { method: "DELETE" });
}
